import { NavLink, Outlet } from "react-router-dom";
import {
  Banknote, LayoutDashboard, ReceiptText, Undo2, Percent,
  Gift, Wallet, ShieldAlert, Activity,
} from "lucide-react";

const TABS = [
  { to: "/finance-os",            label: "Dashboard",     icon: LayoutDashboard, end: true, testid: "fin-tab-dashboard" },
  { to: "/finance-os/payments",   label: "Payments",      icon: ReceiptText,               testid: "fin-tab-payments" },
  { to: "/finance-os/refunds",    label: "Refunds",       icon: Undo2,                     testid: "fin-tab-refunds" },
  { to: "/finance-os/discounts",  label: "Discounts",     icon: Percent,                   testid: "fin-tab-discounts" },
  { to: "/finance-os/comps",      label: "Complimentary", icon: Gift,                      testid: "fin-tab-comps" },
  { to: "/finance-os/cash",       label: "Cash Control",  icon: Wallet,                    testid: "fin-tab-cash" },
  { to: "/finance-os/audit",      label: "Revenue Audit", icon: ShieldAlert,               testid: "fin-tab-audit" },
  { to: "/finance-os/events",     label: "Event Ledger",  icon: Activity,                  testid: "fin-tab-events" },
];

export default function FinanceShell() {
  return (
    <div className="space-y-6" data-testid="finance-shell">
      <div className="flex items-baseline gap-3">
        <div className="w-11 h-11 rounded-xl bg-hocp-gold flex items-center justify-center shrink-0">
          <Banknote className="w-5 h-5 text-hocp-eerie" strokeWidth={2}/>
        </div>
        <div>
          <h1 className="font-display text-[26px] font-bold text-hocp-navy leading-none">Revenue & Finance OS</h1>
          <p className="text-[13px] text-slate-500 mt-1.5">
            Immutable event ledger · Decimal-safe · INR-first · Sole writer for all financial state.
          </p>
        </div>
      </div>

      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive ? "border-hocp-navy text-hocp-navy" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <Icon className="w-4 h-4" strokeWidth={1.75}/>{t.label}
            </NavLink>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
}
